import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import MessagingCopy from '../messaging/MessagingCopy';
import { DataOptions } from '../signup-data/signupDataOptions';
import { getCurrentStep } from '../store/flow/selectors';
import { ButtonsGrid } from '../views-components/ButtonsGrid';
import { StepTitle } from '../views-components/StepTitle';
import { usePrivacyBanner } from '../views-components/usePrivacyBanner';
import { BaseView } from './BaseView';
import { getStepConfig } from './getStepConfig';
import styled from 'styled-components';
const HelperText = styled(MessagingCopy).withConfig({
  displayName: "BaseButtonsView__HelperText",
  componentId: "spwrc2-0"
})(["", ""], props => props.className === 'Hide' && `visibility: hidden;`);
export const BaseButtonsView = ({
  onHighlightChange = () => {},
  onSelect = () => {},
  getButtonText,
  getButtonDescriptionText,
  setDataFn,
  type = 'default',
  footer,
  hasNextButton = false,
  nextButtonLabel,
  hasTooltip = false,
  tooltipLink,
  shouldShowHelperText = true,
  helperTextString,
  helperTitleKey,
  columnCount,
  optionHeight,
  options,
  isSelected,
  expandableSubTitleSection = null,
  shouldDisableAutofocus = false
}) => {
  const stepKey = useSelector(getCurrentStep);
  const {
    shouldShowToSNonOptionalStep
  } = usePrivacyBanner();
  const defaultHelperText = `views.${stepKey}.helperText`;

  if (!stepKey) {
    return null;
  }

  const stepConfig = getStepConfig(stepKey);

  if (!stepConfig) {
    return null;
  } // Supporting only 1 question for now


  const dataKey = stepConfig.data[0];
  const preTitleMessage = `views.${stepKey}.pre-title`;

  const helperText = /*#__PURE__*/_jsx(HelperText, {
    className: !shouldShowHelperText ? 'Hide' : '',
    message: helperTextString || defaultHelperText
  });

  return /*#__PURE__*/_jsx(BaseView, {
    expandableSubTitleSection: expandableSubTitleSection,
    footer: footer,
    helperText: helperText,
    preTitleMessage: preTitleMessage,
    title: /*#__PURE__*/_jsx(StepTitle, {
      hasTooltip: hasTooltip,
      message: helperTitleKey,
      stepKey: stepKey,
      tooltipLink: tooltipLink
    }),
    children: /*#__PURE__*/_jsx(ButtonsGrid, {
      columnCount: columnCount,
      dataKey: dataKey,
      getButtonDescriptionText: getButtonDescriptionText,
      getButtonText: getButtonText,
      hasNextButton: hasNextButton || shouldShowToSNonOptionalStep,
      isSelected: isSelected,
      nextButtonLabel: nextButtonLabel,
      optionHeight: optionHeight,
      options: options || DataOptions[dataKey],
      setDataFn: setDataFn,
      shouldDisableAutofocus: shouldDisableAutofocus,
      stepKey: stepKey,
      type: type || shouldShowToSNonOptionalStep && 'radio',
      onHighlightChange: onHighlightChange,
      onSelect: onSelect
    }, dataKey)
  });
};